<template>
  <template v-if="hasSourceDetails">
    <span class="sources" v-if="object.source">{{ $t("training.rncp.badge.sources") }} : </span>
    <template v-for="source in object.sourceDetails" :key="source.id">
      <button type="button" class="badge source" :class="sourceBadgeClass(source.type)" @click="showDetails">
        {{ sourceCountPrefix(source.type)
        }}{{ $t("training.rncp.source_detail.source." + sourceTranslationKey(source.type))
        }}{{ source.code ? " - " + source.code : "" }}{{ source.label ? " - " + source.label : "" }}
      </button>
    </template>
  </template>
</template>

<script>
import { trainingSourceDetailsConstante } from "@/constantes/trainingSourceDetails";

export default {
  name: "TrainingRncpSourceDetailsComponent",
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
  emits: ["showDetails"],
  computed: {
    hasSourceDetails() {
      return this.object.sourceDetails && Object.keys(this.object.sourceDetails);
    },
  },
  methods: {
    sourceTranslationKey(type) {
      if (type === trainingSourceDetailsConstante.SOURCE_DETAIL_OFFER) {
        if (this.object.jobOfferCount > 1) {
          return "offres";
        } else {
          return "offre";
        }
      }
      const map = {
        rome: trainingSourceDetailsConstante.SOURCE_DETAIL_ROME,
        esco: trainingSourceDetailsConstante.SOURCE_DETAIL_ESCO,
        livret: trainingSourceDetailsConstante.SOURCE_DETAIL_BOOKLET,
      };
      return Object.keys(map).find((key) => map[key] === type) ?? null;
    },

    sourceCountPrefix(type) {
      if (type === trainingSourceDetailsConstante.SOURCE_DETAIL_OFFER && this.object.jobOfferCount) {
        return this.object.jobOfferCount + " ";
      }

      return "";
    },

    sourceBadgeClass(type) {
      return {
        "bg-info": [
          trainingSourceDetailsConstante.SOURCE_DETAIL_ROME,
          trainingSourceDetailsConstante.SOURCE_DETAIL_ESCO,
        ].includes(type),
        "bg-success": type === trainingSourceDetailsConstante.SOURCE_DETAIL_OFFER,
        "bg-danger": type === trainingSourceDetailsConstante.SOURCE_DETAIL_BOOKLET,
      };
    },

    showDetails() {
      this.$emit("showDetails");
    },
  },
};
</script>

<style lang="scss" scoped>
.sources {
  color: $m_color_6;
  font-weight: 700;
}

.source {
  padding: 3px 6px;
  cursor: pointer;
  border: none;
}

.badge + .badge {
  margin-left: 5px;
}
</style>
